import { uploadedConversationPath } from "@/utils/conversationRoutes"

import type { DataSource, DrillDownRunRecord } from "../widgets/types/core"
import { isUploadedConversationSource } from "../widgets/utils/dataSource"

const getUsableId = (value: string | null | undefined): string | null => {
  const normalizedValue = value?.trim()
  return normalizedValue ? normalizedValue : null
}

/**
 * Uploaded-conversation rows link to the uploaded conversation page by
 * `simulation_output_id`, never to a run result.
 */
export const buildDrillDownConversationPath = (
  row: Pick<DrillDownRunRecord, "run_id" | "simulation_output_id">,
  dataSource: DataSource,
): string => {
  if (isUploadedConversationSource(dataSource)) {
    return uploadedConversationPath(row.simulation_output_id)
  }

  const normalizedRunId = getUsableId(row.run_id)
  if (normalizedRunId) {
    return `/simulated/runs/${normalizedRunId}/results/${row.simulation_output_id}`
  }

  return `/simulations/${row.simulation_output_id}`
}

export const getDrillDownConversationLabel = (
  row: Pick<DrillDownRunRecord, "run_id" | "simulation_output_id">,
  dataSource: DataSource,
): string => {
  if (isUploadedConversationSource(dataSource)) {
    return `View details for uploaded conversation ${row.simulation_output_id}`
  }

  const normalizedRunId = getUsableId(row.run_id)
  if (normalizedRunId) {
    return `View details for simulation ${row.simulation_output_id} in run ${normalizedRunId}`
  }

  return `View details for simulation ${row.simulation_output_id}`
}
